import { MonthlyRepeatRule } from '../../../lib/shared/calendar.types'

interface MonthlyRecurrenceProps {
  rule: MonthlyRepeatRule
  onChange: (rule: MonthlyRepeatRule) => void
}

export function MonthlyRecurrence({ rule, onChange }: MonthlyRecurrenceProps) {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700">
        Day of Month
      </label>
      <select
        value={rule.value}
        onChange={(e) =>
          onChange({
            ...rule,
            type: 'dayOfMonth',
            value: parseInt(e.target.value),
          })
        }
        className="mt-1 block w-full rounded-md border border-grey-500 p-2 focus:border-blue-500 focus:ring-blue-500"
      >
        {[...Array(31)].map((_, i) => (
          <option key={i + 1} value={i + 1}>
            {i + 1}
          </option>
        ))}
      </select>
      {rule.value >= 29 && (
        <p className="mt-1 text-sm text-amber-600">
          {rule.value === 31
            ? 'For months with fewer than 31 days, the event will occur on the last day of the month (28th-30th).'
            : rule.value === 30
              ? 'For months with fewer than 30 days, the event will occur on the last day of the month (28th/29th).'
              : 'For February with 28 days, the event will occur on the 28th (or 29th in leap years).'}
        </p>
      )}
    </div>
  )
}
